import React, {ChangeEvent, useRef, useState} from "react";

import {Button, Flex} from "@chakra-ui/react";

import {UploadResult} from "../uploadQueue/types";
import {SUPPORTED_AUDIO_ACCEPT} from "../uploadQueue/supportedAudio";

export type UploadFileMetadata = {
    mimeType?: string
    sizeBytes?: number
    durationMs?: number
}

type Props = {
    onFinishUpload?: (originalFileName: string, fileName: string, filePath: string, metadata?: UploadFileMetadata) => void
    onAllUploadsFinished?: () => void | Promise<void>
    allowMultiple?: boolean
    enqueueUploads: (files: File[], onCompleted: (result: UploadResult) => Promise<void> | void) => void
}

const Upload = ({onFinishUpload, onAllUploadsFinished, allowMultiple, enqueueUploads}: Props) => {
    const uploadRef = useRef<HTMLInputElement | null>(null);
    const [selectedFiles, setSelectedFiles] = useState<FileList | undefined>(undefined);

    const enqueueSelected = (files: FileList) => {
        if (files.length === 0) {
            return;
        }
        enqueueUploads(Array.from(files), async (result) => {
            if (onFinishUpload) {
                onFinishUpload(result.originalFileName, result.fileName, result.filePath, result.metadata);
            }
            if (onAllUploadsFinished) {
                await onAllUploadsFinished();
            }
        });
        setSelectedFiles(undefined);
        if (uploadRef.current) {
            uploadRef.current.value = "";
        }
    };

    const filesSelected = (evnt: ChangeEvent<HTMLInputElement>) => {
        if (evnt.target.files) {
            enqueueSelected(evnt.target.files);
        }
    };

    return (
        <Flex columnGap={2} alignItems={"center"}>
            <input
                type="file"
                accept={SUPPORTED_AUDIO_ACCEPT}
                multiple={allowMultiple === true}
                ref={uploadRef}
                onChange={filesSelected}
                style={{display: "none"}}
            />
            <Button
                size={"sm"}
                variant={"outline"}
                onClick={() => uploadRef.current?.click()}
            >
                Upload file{allowMultiple ? "s" : ""}
            </Button>
        </Flex>
    );
};

export default Upload;
